<script lang="ts">
export default {
  name: 'VirtualList',
};
</script>

<script setup lang="ts">
import { computed, ref } from 'vue';
import { useVirtualizer } from '@tanstack/vue-virtual';

const props = withDefaults(
  defineProps<{
    items: unknown[];
    rowHeight?: number;
  }>(),
  { rowHeight: 50 },
);

const scrollRef = ref<HTMLElement | null>(null);

const virtualizer = useVirtualizer(
  computed(() => ({
    count: props.items.length,
    getScrollElement: () => scrollRef.value,
    estimateSize: () => props.rowHeight,
    overscan: 5,
  })),
);
</script>

<template>
  <div
    ref="scrollRef"
    class="tw:max-h-[680px] tw:w-full tw:min-w-0 tw:overflow-y-auto">
    <div
      :style="{ height: `${virtualizer.getTotalSize()}px`, position: 'relative' }"
      class="tw:w-full tw:min-w-0">
      <div
        v-for="virtualRow in virtualizer.getVirtualItems()"
        :key="String(virtualRow.key)"
        :data-index="virtualRow.index"
        class="tw:absolute tw:top-0 tw:right-0 tw:left-0 tw:w-full tw:min-w-0"
        :style="{ transform: `translateY(${virtualRow.start}px)` }">
        <slot
          name="row"
          :item="items[virtualRow.index]"
          :index="virtualRow.index" />
      </div>
    </div>
  </div>
</template>
